import React from 'react';
import styled from 'styled-components';
import { useStateValue } from '../../State/StateProvider';
import CheckoutProduct from './CheckoutProduct';
import Subtotal from './Subtotal';

function Checkout() {

    const [{ basket, user }, dispatch] = useStateValue();

    return (
        <Container>
            <div className="checkout__left">
                <div>
                    <h1 className="checkout__title">
                        Your Shopping Basket has {basket.length} items
                    </h1>
                    <div className="checkout__right">
                        <Subtotal />
                    </div>
                    {basket.map(item => (
                        <CheckoutProduct
                            id={item.id}
                            title={item.name}
                            image={item.image}
                            price={item.price}
                        />
                    ))}
                </div>
            </div>
        </Container>
    )
}

export default Checkout

const Container = styled.div`
    display: flex;
    padding: 20px;
    background-color: white;
    height: max-content;

    .checkout__title {
        /* margin-right: 10px; */
        margin-bottom: 10px;
        padding-bottom: 1rem;
        /* padding: 10  px; */
        border-bottom: 1px solid lightgray;
        font-size: 2rem;
        color: #000219;
    }
`